import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ListItemButton, ListItem, ListItemText, ListItemIcon, List } from "@mui/material";
import { makeStyles } from "@mui/styles";
import NavigationCard from "./NavigationCard";
import "./Sidebar.style.css";
import { SidebarRoutes} from "./admin.routes";
import { getUserRoleAndScreens } from "../../services/authServices/auth.services";

// custom css
const useStyles = makeStyles({
  buttonRoot: {
    padding: 'auto !important', // This will override the padding property
    // Other styles...
  },
});

const Sidebar = ({ IsSidebarOpen }) => {
  const activePath = window.location.pathname;
  const open = IsSidebarOpen;
  const { role } = getUserRoleAndScreens();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // const handleNestedMenuClick = () => {
  //   setIsMenuOpen(!isMenuOpen);
  // };

  return (
    <React.Fragment>
      <List>
        {/* {role !== "zingworks"
          ? [
              // ...CommonSidebarMenu,
              ...SidebarMenuList,
              ...workPermitReportMenu,
            ].map((route, index) => (
              <NavigationCard
                key={index}
                Icon={route.icon}
                ActiveIcon={route.activeIcon}
                Path={route.path}
                Title={route.title}
                Active={activePath === route.path}
                Open={open}
                IsMenuOpen={isMenuOpen}
                IsNestedMenu={route.isNested}
                SetCollapseMenu={() => setIsMenuOpen(false)}
              />
            ))
          : [...ZingworksAdminSidebarMenu].map((route, index) => (
              
            ))} */}

        {SidebarRoutes.filter((menu) => menu.roles.includes(role)).map(
          (route, index) => (
            <NavigationCard
              key={index}
              Icon={route.icon}
              ActiveIcon={route.activeIcon}
              Path={route.path}
              Title={route.title}
              Active={activePath === route.path}
              Open={open}
              IsMenuOpen={isMenuOpen}
              IsNestedMenu={route.isNested}
              SetCollapseMenu={() => setIsMenuOpen(false)}
            />
          )
        )}
      </List>
    </React.Fragment>
  );
};

// eslint-disable-next-line no-unused-vars
const NestedNavigationCard = ({
  Icon,
  Path,
  Title,
  Active,
  Action,
  Open,
}) => {
  const navigation = useNavigate();
  const handleNavigation = () => {
    navigation(Path);
  };
  // eslint-disable-next-line no-unused-vars
  const classes = useStyles();
  return (
    <ListItem
      className="custom-list-item"
      sx={{ display: "block", width: "100%" }}
    >
      {/* <Tooltip title={Title} placement="left"> */}
        <ListItemButton
          className={
            Active
              ? `sidebar-menu list-item-btn-active custom-list-button`
              : `sidebar-menu list-item-btn custom-list-button`
          }
          sx={{
            justifyContent: Open ? "initial" : "center",
            borderRadius: "12px",
            // minHeight: 48,
            px: 2.5,
          }}
          onClick={Action ? Action : handleNavigation}
        >
          <ListItemIcon
            className="custom-list-icon"
            style={{
              color: Active ? "#fff" : "#828282",
              // fontSize: "20px",
              marginLeft: Open ? "" : "15px",
            }}
            sx={{
              minWidth: 0,
              mr: Open ? 3 : "auto",
              // justifyContent: "center",
            }}
          >
            {Icon}
          </ListItemIcon>
          <ListItemText
            className="custom-list-text"
            primary={Title}
            style={{
              color: Active ? "#fff" : "#828282",
              textWrap: "wrap",
            }}
          />
        </ListItemButton>
      {/* </Tooltip> */}
    </ListItem>
  );
};
export default Sidebar;
